import { render, staticRenderFns } from "./update-general-subscription-setting.vue?vue&type=template&id=565ce1f2&scoped=true"
import script from "./update-general-subscription-setting.vue?vue&type=script&lang=js"
export * from "./update-general-subscription-setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565ce1f2",
  null
  
)

export default component.exports